import { Tab, TabGroup } from "@commonlibs";
import { MainTabsGroupProps } from "./MainTabs.types";
import clsx from "clsx";

function MainTabsGroup({ className, tabs, ...rest }: MainTabsGroupProps) {
    return (
        <TabGroup className={clsx("main-tabs-group", className)} {...rest}>
            {tabs.map((tab, index) => (
                // @ts-ignore skipcq
                <Tab icon={tab.icon} index={index} key={index}>
                    {tab.label}
                </Tab>
            ))}
        </TabGroup>
    );
}

export default MainTabsGroup;
